// import * as L from "leaflet";
import { decode } from "@mapbox/polyline";
import { CircularProgress } from "@material-ui/core";
import "leaflet/dist/leaflet.css";
import React, { useCallback, useEffect, useState } from "react";
import { clearIntervalAsync } from "set-interval-async";
import { setIntervalAsync } from "set-interval-async/dynamic";
import RNEtaCard from "../../components/RNEtaCard";
import RNMapComp from "../../components/RNMap/index";
import { getRouteStopEta, getRouteTraffic } from "../../utils/api";
import { hideStopDroppingStragegy, langStringConvertor } from "../../utils/utils";
import "./styles.scss";



const Eta = (props) => {
  const { lang, routes, displayType, setCurrentTitle, court, routeNetwork, hideStop, etaDisplayMethod, themeColour } =
    props;
  const { routeId, routeSeq } = props.match.params;

  const RNRoute = routeNetwork.find(
    (el) => `${el.normalRouteId}` === routeId && `${el.routeSeq}` === routeSeq
  );
  // console.log("RNRoute", RNRoute);
  const route = routes.find((el) => `${el.route_id}` === routeId);
  const directionsStops = route?.routeStops;
  const [path, setPath] = useState([]);
  const [stops, setStops] = useState([]);
  const [vehicleLocations, setVehicleLocations] = useState(null);
  const [traffic, setTraffic] = useState([]);
  const [etaCardMsg, setEtaCardMsg] = useState(null);

  const [bounds, setBounds] = useState(new window.google.maps.LatLngBounds());

  const [isLoading, setIsLoading] = useState(true);

  const [isFirstTime, setIsFirstTime] = useState(true);

  const getStopsInfo = useCallback(async () => {
    // console.log("RNRoute", RNRoute);
    const tempEta2 = await Promise.all(
      RNRoute.routeIds.flatMap(async (el, index) => {
        const eta = await getRouteStopEta(el, RNRoute.routeSeq);
        // console.log("eta", eta);

        return {
          ...eta,
          vehicleLocation: Object.values(eta.vehicleLocation).map(
            (ele, index) => ({
              ...ele,
              vehicleId: Object.keys(eta.vehicleLocation)[index],
              routeId: el,
            })
          ),
          eta: eta.eta.map((ele, ind) => ({
            ...ele,
            routeId: el,
            stopId: RNRoute.routeList[el][ind],
            eta: ele.eta.map((ele) => ({ ...ele, routeId: el })),
          })),
        };
      })
    );
    // console.log(tempEta2);
    const tempStops = RNRoute.route_stops.map((el, index) => {
      const etas = tempEta2
        .flatMap((ele) => ele.eta)
        .filter((ele) => ele.stopId === el.stop_id)
        .flatMap((ele) => ele.eta)
        .sort((a, b) => a.diff - b.diff);
      // console.log(etas);
      return {
        ...el,
        ...RNRoute.stops[index],
        eta: etas.map((el, ind) => ({ ...el, eta_seq: ind + 1 })),
      };
    });

    let tempVL = [];
    tempEta2.map((el) => {
      tempVL = [...tempVL, ...el["vehicleLocation"]];
    });

    // console.log(tempVL);
    setVehicleLocations(tempVL);

    setStops(tempStops);
  }, [RNRoute]);

  const getPath = useCallback(async () => {
    const tempBounds = bounds || new window.google.maps.LatLngBounds();
    if (RNRoute) {
      const tempPath = RNRoute.routeIds.map((el) => {
        const pathCoords = decode(RNRoute.shapes[el]).map((latlng) => {
          const latLng = new window.google.maps.LatLng(latlng[1], latlng[0]);
          tempBounds.extend(latLng);
          return { lat: latlng[1], lng: latlng[0] };
        });
        return { routeId: el, shape: pathCoords };
      });
      // console.log(tempPath);
      setBounds(tempBounds);
      setPath(tempPath);
    }
  }, [RNRoute, bounds]);

  const getTraffic = useCallback(async () => {
    if (RNRoute) {
      await Promise.all(
        RNRoute.routeIds.map(async (el) => {
          return { traffic: await getRouteTraffic(el, routeSeq), routeId: el };
        })
      ).then((result) => {
        setTraffic(result);
      });
    }
  }, [RNRoute, routeSeq]);

  const getCurrentTitle = useCallback(() => {
    if (route) {
      const origin = route.directions.find(
        (el) => `${el.route_seq}` === `${routeSeq}`
      )[`orig_${langStringConvertor(lang)}`];
      const destination = route.directions.find(
        (el) => `${el.route_seq}` === `${routeSeq}`
      )[`dest_${langStringConvertor(lang)}`];

      setCurrentTitle(
        lang === "zh" || lang === "cn"
          ? displayType === "combineStops"
            ? `來往 ${destination}`
            : `由 ${origin} 往 ${destination}`
          : displayType === "combineStops"
          ? `To ${destination}`
          : `From ${origin} To ${destination}`
      );
    }
  }, [displayType, lang, route, routeSeq, setCurrentTitle]);

  useEffect(() => {
    const getData = async () => {
      await getStopsInfo();
      await getPath();
      await getTraffic();
    };

    if (isFirstTime && routes && routes.length > 0) {
      getCurrentTitle();
      getData();
      setIsFirstTime(false);
      setIsLoading(false);
    }
  }, [
    displayType,
    getCurrentTitle,
    getPath,
    getStopsInfo,
    getTraffic,
    isFirstTime,
    routes,
    setCurrentTitle,
  ]);

  useEffect(() => {
    const timer = setIntervalAsync(async () => {
      await getStopsInfo();
      // await getEta();
      await getTraffic();
    }, 10000);

    return () => {
      clearIntervalAsync(timer);
    };
  }, [displayType, getStopsInfo, getTraffic]);

  return (
    <>
      {isLoading ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="progress-container"
        >
          <CircularProgress color="primary" />
        </div>
      ) : (
        <>
          {path.length > 0 ? (
            <RNMapComp
              path={path}
              stops={stops}
              bounds={bounds}
              court={court}
              vehicleLocations={vehicleLocations}
              traffic={traffic}
              RNRoute={RNRoute}
              themeColour={themeColour}
            />
          ) : null}
          {stops.length > 0 && (
            <RNEtaCard
              stops={hideStopDroppingStragegy(hideStop)(stops)}
              lang={lang}
              description={RNRoute.descriptions}
              message={etaCardMsg}
              etaDisplayMethod={etaDisplayMethod}
            />
          )}
        </>
      )}
    </>
  );
};

export default Eta;
